import { cloneDeep } from "lodash";

const DEFAULT_ATTRIBUTES = {
  code: null,
  description: null,
  discounted: null,
  price: null,
  read_only: null,
  reference: null,
  resource_id: null,
  seller_id: null,
  tax_price: null,
};

export class Charge {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });
  }
}
